export default "__VITE_ASSET__eyayxV5U__"